/* eslint-disable new-cap */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useOutletContext } from 'react-router-dom';
import * as Yup from 'yup';
import { IReport } from '../../../interfaces/Models';
import { reportTypes } from '../../../common/Constants';
import ErrorMessage from '../../../components/ErrorMessage';
import { HMBFirstValues } from '../../../common/reportsFieldsValues/hmb/HMBFirstValues';
import HMBFirstFields from './fields/HMBFirstFields';
import ReportsForm from '../../../components/Form/ReportsForm';

const HMBFirst = () => {
  const { t } = useTranslation();
  const { visitId } = useParams();
  const data: IReport = useOutletContext();

  const initialValues = data
    ? data
    : {
        name: reportTypes.HMB_FIRST,
        visit: visitId,
        data: HMBFirstValues,
      };
  const ReportSchema = Yup.object({
    name: Yup.string().required(t('clinic.form.required')),
    visit: Yup.string().required(t('clinic.form.required')),
  });

  const HtmlId = 'HMBFirst';

  if (data && data.name != reportTypes.HMB_FIRST) {
    return <ErrorMessage error={t('global.errors.somethingWrong')} />;
  }
  return (
    <ReportsForm
      initialValues={initialValues}
      visitId={visitId || ''}
      validationSchema={ReportSchema}
    >
      <HMBFirstFields id={HtmlId} />
    </ReportsForm>
  );
};

export default HMBFirst;
